
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { GetStaticPropsContext } from 'next';
import Head from 'next/head';
import { isFilled, asImageSrc } from '@prismicio/client';
import { SliceZone } from '@prismicio/react';
import { useRouter } from 'next/router';
import * as prismic from '@prismicio/client';
import EolaLayout from '../../library/atoms/EolaLayout';
import { components } from '../../slices';
import { createClient } from '../../prismicio';
import { PrismicPreview } from '@prismicio/next';
import { repositoryName } from 'prismicio';
import { titleize } from 'shared/helpers/stringUtilities';
import type { Content } from '@prismicio/client';
type Params = {
    uid: string;
};
type PageProps = {
    page: Content.LocationDocument;
    noindex: boolean;
};
const locationGraphQuery = `
  {
    location {
      meta_title
      meta_description
      meta_image
      slices {
        ...on content_with_hexagon_images {
          variation {
            ...on default {
              primary {
                ...primaryFields
              }
            }
            ...on shared {
              primary {
                shared_content {
                  ...on content_hero {
                    ...content_heroFields
                  }
                }
              }
            }
          }
        }
        ...on activity_carousel {
          variation {
            ...on default {
              primary {
                ...primaryFields
              }
            }
            ...on list {
              primary {
                ...primaryFields
              }
            }
          }
        }
          ...on location_tag_cloud {
          variation {
            ...on default {
              primary {
                ...primaryFields
              }
            }
          }
        }
          ...on category_list {
          variation {
            ...on default {
              primary {
                ...primaryFields
              }
            }
          }
        }
        ...on frequently_asked_questions {
          variation {
            ...on default {
              primary {
                ...primaryFields
              }
            }
          }
        }
        ...on multi_column {
          variation {
            ...on default {
              primary {
                ...primaryFields
              }
            }
          }
        }
        ...on spacer {
          variation {
            ...on default {
              primary {
                ...primaryFields
              }
            }
          }
        }
        ...on card_grid {
           variation {
            ...on default {
              primary{
                ...primaryFields
              }
            }
          }
        }
      }
    }
  }`
    .split(/\r?\n/)
    .map(row => row.trim().split(/\s+/).join(' '))
    .join('\n');
export default function Page({ page, noindex }: PageProps) {
    const { query } = useRouter();
    // We use the uid to build pages when a curated page does not exist on
    // prismic. We titleize as this text is used in titles and other content
    // automatically built for the page
    const uid = titleize(query.uid as string);
    return (<>
      <PrismicPreview repositoryName={repositoryName}/>
      <Head>
        {noindex && <meta name="robots" content="noindex"/>}

        {isFilled.keyText(page.data.meta_title) ? (<title>{page.data.meta_title.replace('{uid}', uid)}</title>) : null}
        {isFilled.keyText(page.data.meta_description) ? (<meta name="description" content={page.data.meta_description.replace('{uid}', query.uid as string)}/>) : null}
        {isFilled.keyText(page.data.meta_title) ? (<meta property="og:title" content={page.data.meta_title.replace('{uid}', uid as string)}/>) : null}
        <meta property="og:type" content="WebSite"/>
        <meta property="og:url" content={`https://eola.co/location/${page.uid.toLowerCase()}`}/>
        {isFilled.image(page.data.meta_image) && (<meta property="og:image" content={asImageSrc(page.data.meta_image)}/>)}
      </Head>

      <EolaLayout>
        <SliceZone slices={page.data.slices} components={components}/>
      </EolaLayout>
    </>);
}
async function getStaticProps({ params, previewData }: GetStaticPropsContext<Params>) {
    // The `previewData` parameter allows your app to preview
    // drafts from the Page Builder.
    const client = createClient({ previewData });
    let page = null;
    let noindex = false;
    try {
        page = await client.getFirst({
            filters: [
                prismic.filter.fulltext('my.location.url', encodeURIComponent(params!.uid)),
                prismic.filter.at('document.type', 'location')
            ],
            graphQuery: locationGraphQuery
        });
    }
    catch (error) {
        page = await client.getByUID('location', 'location-default', {
            graphQuery: locationGraphQuery
        });
        noindex = true;
    }
    // Redirect to a lowercase version of a page. We previously had this as case sensitive so
    // London and london urls where 2 seperate pages. Now the London page is server by london
    // this includes prismic pages being case insensitive.
    if (/[A-Z]/.test(params!.uid)) {
        return {
            redirect: {
                destination: `/location/${params!.uid.toLowerCase()}`,
                permanent: true
            }
        };
    }
    return {
        props: { page: page, noindex: noindex },
        revalidate: 1
    };
}
export async function getStaticPaths() {
    return {
        paths: [],
        fallback: 'blocking'
    };
}

    async function __Next_Translate__getStaticProps__1966c8deaea__(ctx) {
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/location/[uid]',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1966c8deaea__ as getStaticProps }
  